/**
 * Strict https-only URL check for safely linkifying untrusted evidence values.
 *
 * A value qualifies only when, after trimming, it starts with the literal
 * "https://" prefix AND parses via `new URL()` with an `https:` protocol.
 * http:, javascript:, data:, and malformed values are all rejected so that
 * scanner/integration output can never become a non-https anchor.
 */
export const isHttpsUrl = (value: string): boolean => {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (!trimmed.startsWith('https://')) return false;
  try {
    return new URL(trimmed).protocol === 'https:';
  } catch {
    return false;
  }
};
